import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/ui/dropdown-menu';
import { Button } from 'components/ui/button';
import { Switch } from 'components/ui/switch';
import DownChevronIcon from 'components/icons/downchevron';
import { ProcessorWebhookConfig } from 'types/settings/internalConfig';

interface WebhookConfigRowProps {
  config: ProcessorWebhookConfig;
  onToggle: (processorId: string, value: boolean) => void;
  onStatusChange: (processorId: string, status: string) => void;
}

export const WebhookConfigRow: React.FC<WebhookConfigRowProps> = ({
  config,
  onToggle,
  onStatusChange,
}) => {
  const selectedLabel =
    config.statusOptions.find((option) => option.value === config.webhookStatus)
      ?.label || 'Please select';

  return (
    <div className="flex items-center py-3 border-b border-gray-200">
      <div className="w-[30%]">
        <span className="font-normal text-sm leading-5 text-gray-blue-70">
          {config.processorName}
        </span>
      </div>

      <div className="w-[40%]">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              type="button"
              variant="secondary"
              size="sm"
              data-testid={`webhook_status_dropdown_${config.processorId}`}
              className="font-normal w-[324px] justify-between py-2"
              disabled={!config.bypassEnabled}
            >
              {selectedLabel}
              <DownChevronIcon />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {config.statusOptions.map((option) => (
              <DropdownMenuItem
                key={option.value}
                onClick={() => onStatusChange(config.processorId, option.value)}
              >
                {option.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <div className="w-[30%] flex justify-end">
        <Switch
          id={`bypassToggle_${config.processorId}`}
          checked={config.bypassEnabled}
          onCheckedChange={(checked) => onToggle(config.processorId, checked)}
          className="mt-1"
        />
      </div>
    </div>
  );
};
